import React from "react";
import { useState, useCallback, useEffect } from "react";
import {
  csv,
  arc,
  pie,
  scaleBand,
  scaleLinear,
  max,
  format,
  tickFormat,
} from "d3";
import "./FirstBarChart.css";
import BarIcon from "../Icons/BarIcon";

const csvUrl =
  "https://gist.githubusercontent.com/VasumathiArichandran/bb9a63af56bea24c835e1e4063efeaec/raw/d16d24f36a1c838f11096c411ae8cb2f34ad5f50/Population.csv";

const width = 95;
const height = 280;
const margin = { top: 0, right: 0, bottom: 0, left: 0 };
export default function () {
  const [data, setData] = useState(null);
  useEffect(() => {
    const row = (d) => {
      d.Population = +d["2050"];
      return d;
    };
    csv(csvUrl, row).then(setData);
  }, []);

  if (!data) {
    return <pre>Loading...</pre>;
  }
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  console.log(data[0]);
  const yScale = scaleBand()
    .domain(data.map((d) => d["Country or area"]))
    .range([0, height])
    .padding(0.4);

  const xScale = scaleLinear()
    .domain([0, max(data, (d) => d.Population)])
    .range([0, innerWidth]);
  console.log(xScale.ticks());

  return (
    <>
      <div className="BarChart">
        <div>
          <div className="BarChartHeading">
            <BarIcon />
            <p className="MerchantJoin">Merchant Join</p>
          </div>
          <div className="BarChartSubHeading">
            <p className="Three089">3089</p>
            <p className="plus29">+29%</p>
          </div>
        </div>
        <svg width={width} height={height} className="BarChartBar">
          <g
            transform={`translate(${margin.left},${margin.top})`}
            width={width}
            height={height}
          >
            {/* </g> {xScale.ticks().map((tickValue) => ( */}
            {/* <g */}
            {/* key={tickValue}
                 transform={`translate(${xScale(tickValue)},0)`}
               >
                <line y2={innerHeight} stroke="#c0c0bb" />
                 <text */}
            {/* className="xScaleText"
                  style={{ textAnchor: "middle", fontSize: "4px" }}
                  dy="1.71em"
                  y={innerHeight}
                 > */}
            {/* {tickFormat(tickValue)} */}
            {/* {format(".2s")(tickValue).replace("G", "B")}
                 </text>
               </g>
            ))} */}
            {/* {yScale.domain().map((tickValue) => (
              <text
                key={tickValue}
                className="xScaleText"
                style={{ textAnchor: "end", fontSize: "4px" }}
                dx="-29.31em"
                x={innerWidth}
                y={yScale(tickValue) + yScale.bandwidth() / 2}
              >
                {tickValue}
              </text>
            ))} */}
            {/* <text
              x={innerWidth / 2}
              y={innerHeight + 15}
              style={{ textAnchor: "middle", fontSize: "10px" }}
            >
              Population
            </text> */}
            {data.map((d) => (
              <rect
                className="mark"
                key={d["Country or area"]}
                x={0}
                y={yScale(d["Country or area"])}
                rx={2}
                ry={2}
                width={xScale(d.Population)}
                height={yScale.bandwidth()}
              />
            ))}
          </g>
        </svg>
        <div className="BarChartFooter1">
          <div className="BarChartFooter1Sub">
            <BarIcon />
            <p>User Register</p>
          </div>
          <p className="BarChartFooter2Sub">+13%</p>
        </div>
        <div className="BarChartFooter1">
          <div className="BarChartFooter1Sub">
            <BarIcon />
            <p>UseBuying</p>
          </div>

          <p className="BarChartFooter2Sub">+72%</p>
        </div>
      </div>
    </>
  );
}
